import { render, staticRenderFns } from "./PdfMain.vue?vue&type=template&id=01d4f09d&scoped=true"
import script from "./PdfMain.vue?vue&type=script&lang=js"
export * from "./PdfMain.vue?vue&type=script&lang=js"
import style0 from "./PdfMain.vue?vue&type=style&index=0&id=01d4f09d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01d4f09d",
  null
  
)

export default component.exports